const DAYS_PER_MONTH = 146097 / 400 / 12;
const SECONDS_PER_HOUR = 60 * 60;
const SECONDS_PER_MINUTE = 60;
export const formattedStartTime = "00:00:00";

export function getSeconds(hms) {
    if (typeof hms === "number") {
        return hms;
    }

    const time = formatToStandardTime(hms);
    const timeSplit = time.split(":");
    const hours = +timeSplit[0];
    const minutes = +timeSplit[1];
    const seconds = +timeSplit[2];

    return hours * SECONDS_PER_HOUR + minutes * SECONDS_PER_MINUTE + seconds;
}

export function getTimeText(time) {
    return time && time.split(".")[0];
}

export function formatToStandardTime(time, padMilliSeconds = false, padNum = 3) {
    if (typeof time === "number") {
        time = toTimeText(time);
    }

    time = time?.toString();
    const displayTime = time?.split(".");

    if (!displayTime || !displayTime[0]) {
        return "";
    }
    const timeSplit = displayTime[0]?.split(":");
    const hours = timeSplit[0]?.padStart(2, "0");
    const minutes = timeSplit[1]?.padStart(2, "0");
    const seconds = timeSplit[2]?.padStart(2, "0");
    const milliseconds =
        displayTime[1] && !isNaN(displayTime[1])
            ? "." + `${+displayTime[1] / Math.pow(10, displayTime[1]?.length)}`?.split(".")[1]?.padEnd(padNum, "0")
            : padMilliSeconds
            ? ".".padEnd(padNum + 1, "0")
            : "";

    return hours + ":" + minutes + ":" + seconds + milliseconds;
}

export function toTimeText(time, roundSeconds = false) {
    const sec_num = time; // don't forget the second param
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;
    if (roundSeconds) {
        seconds = Math.round(seconds);
    }
    if (seconds === 60) {
        seconds = 0;
        minutes++;
        if (minutes === 60) {
            minutes = 0;
            hours++;
        }
    }

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds;
}